<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="メール受信設定"
      />
      <p>通知メールの受信設定を行います。</p>
      <form-item-group
        v-model="receivableMailTypes"
        :options="receivableMailTypeOptions"
        :form-label-class-name="'pega-form-label-account'"
      >
        <template #label>
          メール受信設定&nbsp;
          <small>(任意)</small>
        </template>
      </form-item-group>
      <form-button-area>
        <form-confirm-button
          button-class="pega-width-auto"
          submit-label="この内容で保存する"
          data-test="confirm-button"
          @submit-event="onRegisterClick"
        />
      </form-button-area>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormItemGroup from '@/components/atoms/FormItemGroup'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import { mapGetters } from 'vuex'
export default {
  components: {
    SettingHeader,
    FormItemGroup,
    FormButtonArea,
    FormConfirmButton
  },
  data () {
    return {
      receivableMailTypes: []
    }
  },
  computed: {
    ...mapGetters({
      receivableMailTypeOptions: 'receivableMailTypesMaster'
    })
  },
  created () {
    this.fetchStaff()
  },
  methods: {
    onRegisterClick () {
      this.$emit(
        'submit',
        {
          receivableMailTypeIds: this.receivableMailTypes
        }
      )
    },
    fetchStaff () {
      this.$http.secured.get('/account/mail/edit/settings')
        .then(response => {
          this.$set(this, 'receivableMailTypes', response.data.receivableMailTypes.map(receivableMailType => receivableMailType.id))
        })
    }
  }
}
</script>
